// extracted by mini-css-extract-plugin
export default {"price":"c7-z","onSale":"d7-z","msrpLabelPrice":"e7-z","msrpLabel":"f7-z","originalPrice":"g7-z","percentOff":"h7-z"};